var map = {
	"./posionicon-1.png": "7c95",
	"./posionicon-2.png": "0ea6",
	"./posionicon-3.png": "c740",
	"./posionicon-4.png": "e4a0",
	"./posionicon-5.png": "c6c5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ab24";